<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
					<div class="col-lg-3">
						<div class="avatar-upload-histequipo">
                            <div v-show="!Disabled" class="avatar-edit">
                                <input :disabled="Disabled" id="file" @change="CambiarImagen($event)" ref="file" type="file" name="file" accept=".png, .jpg, .jpeg">
                                <label for="file"></label>
                            </div>
                            <div class="avatar-edit2">
                                <button type="button" data-backdrop="static"
                                data-toggle="modal"
                                data-target="#imagen" @click="ZoomImagen(ImagenAMostrar)">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                            <!-- <div v-if="BndImagenEquipo!=0" class="avatar-edit3">
                                <button type="button" @click="GuardarImagenEquipo">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div> -->
                            <div class="avatar-preview">
                                <div id="imagePreview" :style="'background-image: url('+ImagenAMostrar+');'" :src="ImagenAMostrar">
                                </div>
                            </div>
                        </div>
					</div>
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-3">
                    		    <label >SKU </label>
                    		    <input :disabled="Disabled" type="text" v-model="material.Codigo" class="form-control" placeholder="SKU" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Codigo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>

                    		<div class="col-lg-4">
                    		    <label >Ítem </label>
								<div class="position-relative">
									<input :disabled="Disabled" type="text" v-model="material.Item" class="form-control" placeholder="Ítem" @input="onInput" @blur="hideSuggestions" @focus="onFocus"/>
									<ul v-if="ShowList && ItemFiltrado.length" class="suggestions">
										<li v-for="(item,index) in ItemFiltrado" :key="index" @mousedown.prevent="selectSuggestion(item)">
											{{item}}
										</li>
									</ul>
								</div>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>

							<div class="col-lg-2">
								<label for="">Unidad</label>
								<div class="position-relative">
									<input :disabled="Disabled" type="text" class="form-control" v-model="material.Unidad" placeholder="Unidad" @input="onInputUnidad" @blur="hideSuggestionsUnidad" @focus="onFocusUnidad">
									<ul v-show="ShowListUnidad && UnidadFiltrado.length" class="suggestions">
										<li v-for="(item,index) in UnidadFiltrado" :key="index" @mousedown.prevent="selectSuggestionUnidad(item)">
											{{item}}
										</li>
									</ul>
								</div>
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Marca</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="material.Marca" placeholder="Marca">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="this.errorvalidacion.Marca[0]"></Cvalidation></label>
							</div>	
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label>Modelo</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="material.Modelo" placeholder="Modelo">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="this.errorvalidacion.Modelo[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                		        <label >Costo Unitario</label>
                		        <vue-numeric :disabled="Disabled" placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="material.Precio"></vue-numeric>
                		        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Precio" :Mensaje="this.errorvalidacion.Precio[1]"></Cvalidation></label>
                		    </div>
							<div class="col-lg-3">
								<label for="">Stock</label>
								<select :disabled="Disabled" v-model="material.Stock" class="form-control">
									<option value="">- Stock -</option>
									<option value="stock">Stock</option>
									<option value="bajo pedido">Bajo Pedido</option>
								</select>
								<!-- <input @input="CambiarFechaStock" type="number" class="form-control" v-model="material.Stock" placeholder="Stock"> -->
								<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
							</div>
							<div class="col-lg-5">
								<label for="">Archivo</label>
                        		<div class="custom-file-input-image">
                        		    <input :disabled="Disabled" @change="SubirArchivo()" type="file" accept="application/pdf" ref="archivo" class="custom-file-input" id="validatedCustomFile" required>
                        		    <input :disabled="Disabled" type="text" v-model="NombreArchivo" class="form-control">
                        		    <button :disabled="Disabled" type="button" class=""><i class="fas fa-paperclip"></i></button>
                        		</div>
							</div>
						</div>
					</div>
                </div>
				<div class="row">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea :disabled="Disabled" v-model="material.NomMaterial" maxlength="70" cols="30" rows="1" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
                <!--Fin body del panel-->
            </template>
        </CLoader>
		<Modal :Showbutton="false" :NameModal="'imagen'" :Nombre="'Imagen'" :TipoM="2">
            <template slot="Form">
				<div class="form-row justify-content-center align-items-center">
					<img :src="ImagenAMostrar" alt="Aún no hay una imagen para mostrar" class="img-thumbnail">
				</div>
			</template>
        </Modal>
    </div>
     
</template>
<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import Modal from '@/components/Cmodal.vue';
import Config from "@/helpers/VarConfig.js";

export default {
    name:'Form',
    props:['NameList','poBtnSave','pDisabled'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'tipounidad',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            material:{            
                IdMaterial:0,
                Codigo:"S/N",
                NomMaterial:"",
                Precio:"",
				Item:"",
				Unidad:"",
				Stock:'',
				Marca:"",
				Modelo:"",
				Foto:"",
				Archivo:""
            },
            urlApi:"cotizacion_materialdistribuidor/recovery",
            errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ItemsMaterial:[],
			ShowList:false,
			ItemsUnidad:[],
			ShowListUnidad:false,
			Disabled:false,
			ValidElement:Config.validImage2m,
			ImagenAMostrar:'',
			NombreArchivo:'',
        }
    },
    components:{
        Cbtnsave,
        Clist,Cvalidation,Modal
    },
    methods :
    {
    
       async Guardar()
        {
             //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			let file=this.$refs.archivo.files[0];
			formData.set('IdMaterial',this.material.IdMaterial);
			formData.set('NomMaterial',this.material.NomMaterial);
			formData.set('Precio',this.material.Precio);
			formData.set('Codigo',this.material.Codigo);
			formData.set('Unidad',this.material.Unidad);
			formData.set('Stock',this.material.Stock);
			formData.set('Item',this.material.Item);
			formData.set('Marca',this.material.Marca);
			formData.set('Modelo',this.material.Modelo);
			formData.set('Foto',this.material.Foto);
			formData.set('Archivo',this.material.Archivo);
			formData.append('FotoFile',image);
			formData.append('ArchivoFile',file);
            await this.$http.post(
                'cotizacion_materialdistribuidor/post',
                formData,
				{
                headers:{
                    'Content-Type':'multipart/form-data'
                }  
            }
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion); 

            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  

            });
       
        },
         Limpiar()
        {
            this.material.IdMaterial=0;
            this.material.NomMaterial="";
            this.material.Codigo="S/N";
            this.material.Precio="";
			this.material.Item="";
			this.material.Unidad="";
			this.material.Marca="";
			this.material.Modelo="";
			this.material.Stock='';
			this.material.Foto='';
			this.material.Archivo='';
			// this.material.FechaStock='';
			// this.StockOriginal=0;
			// this.FechaStockOriginal=new Date();
            this.errorvalidacion=[];
			this.ImagenAMostrar='';
			this.NombreArchivo='';
			this.$refs.file.value=null;	
            
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdMaterial: this.material.IdMaterial}
                }
            ).then( (res) => {
                this.material=res.data.data.material;
				this.ImagenAMostrar=res.data.data.ruta+this.material.Foto;
				this.NombreArchivo=res.data.data.material.Archivo;
				// if (res.data.data.material.FechaStock!=null) {
				// 	let formatedDate = res.data.data.material.FechaStock.replace(/-/g, "\/");
                // 	this.material.FechaStock=new Date(formatedDate)
				// 	this.FechaStockOriginal=new Date(formatedDate);	
				// }
				// else{
				// 	this.material.FechaStock=new Date();
				// 	this.FechaStockOriginal=new Date();
				// }
				// this.StockOriginal=res.data.data.material.Stock;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		// CambiarFechaStock(){
		// 	if (this.material.Stock!=this.StockOriginal) {
		// 		this.material.FechaStock=new Date();
		// 	}
		// 	else{
		// 		this.material.FechaStock=this.FechaStockOriginal;
		// 	}
		// },
		ListItem(){
			this.$http.get('cotizacion_materialdistribuidor_item/get').then((res)=>{
				this.ItemsMaterial=res.data.data.row;
			})
		},
		ListUnidad(){
			this.$http.get('cotizacion_materialdistribuidor_unidad/get').then((res)=>{
				this.ItemsUnidad=res.data.data.row;
			})
		},
		onInput() {
    	  	this.ShowList = true;
    	},
    	selectSuggestion(item) {
    	  	this.material.Item = item;
    	  	this.ShowList = false;
    	},
		hideSuggestions() {
     		 // Delay to allow click event on suggestion to trigger before hiding
     		 setTimeout(() => {
     		   this.ShowList = false;
     		 }, 100);
    	},
		onFocus() {
      		if (this.material.Item) {
        		this.ShowList = true;
      		}
    	},
		onInputUnidad() {
    	  	this.ShowListUnidad = true;
    	},
    	selectSuggestionUnidad(item) {
			// console.log(item);
    	  	this.material.Unidad = item;
    	  	this.ShowListUnidad = false;
    	},
		hideSuggestionsUnidad() {
     		 // Delay to allow click event on suggestion to trigger before hiding
     		 setTimeout(() => {
     		   this.ShowListUnidad = false;
     		 }, 100);
    	},
		onFocusUnidad() {
      		if (this.material.Unidad) {
        		this.Unidad = true;
      		}
    	},
		CambiarImagen(target){
            this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
        },
		ZoomImagen(Imagen){
            if (this.$refs.file.files[0]!=undefined) {
				let ImagenPreview=document.getElementById("imagePreview");
				const Estilos=window.getComputedStyle(ImagenPreview);
				let CadenaBase=Estilos.backgroundImage;
				let Url=CadenaBase.slice(5,-2);
				this.ImagenAMostrar=Url;
			}
			else{
				this.ImagenAMostrar=Imagen;
			}
        },
		SubirArchivo(){
			const image = this.$refs.archivo.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 5) {
                this.$toast.info('Solo se puede subir archivos menores a 5 MB');
                const  input  = this.$refs.archivo;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivo;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (5MB)';
                return false;
            }

            this.NombreArchivo=image.name;
		}

    },
    created() {
        
        this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   
			this.ListItem();
			this.ListUnidad();
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.material.IdMaterial=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });
       
    },
	mounted() {
		if (this.pDisabled!=undefined) {
			this.Disabled=this.pDisabled;
		}
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
		ItemFiltrado(){
			// console.log(this);
			if (this.ItemsMaterial.length>0) {
				const input = this.material.Item.toLowerCase();
      			return this.ItemsMaterial.filter((item) =>
      			  item.toLowerCase().includes(input)
      			);	
			}
		},
		UnidadFiltrado(){
			// console.log(this);
			if (this.ItemsUnidad.length>0) {
				const input = this.material.Unidad.toLowerCase();
      			return this.ItemsUnidad.filter((item) =>
      			  item.toLowerCase().includes(input)
      			);	
			}
		}
    }
}
</script>
